import type { FC } from 'react';
import React from 'react';
import { Box, ButtonV2, DrawerV2, Flex, TextV2 } from '@withjoy/joykit';
import { Filter } from '@withjoy/joykit/icons';
import { useCategoryFilterController } from './CategoryFilterMobile.controller';
import type { CategoryFilterData } from '../../BrandsList.controller';
import { StyleCheckbox, StyledFilterFloatingButton, styles } from './CategoryFilterMobile.styles';
import type { TranslateFunction } from '@locales/generated';

export interface CategoryFilterMobileProps {
  translations: {
    filter: TranslateFunction;
    shopBy: TranslateFunction;
    clearAll: TranslateFunction;
    confirm: TranslateFunction;
  };
  categories?: CategoryFilterData[];
  selectedItem: CategoryFilterData;
  handleSelect: (item: CategoryFilterData, disableClear?: boolean) => void;
  handleClear: () => void;
}

export const CategoryFilterMobile: FC<CategoryFilterMobileProps> = props => {
  const { translations, categories } = props;

  const { isDialogOpen, onDialogOpen, onClearClick, onConfirmClick, onSelect, selectedItem, onClose, hasBottomBar } = useCategoryFilterController(props);

  return (
    <>
      <StyledFilterFloatingButton
        __css={styles.filterFloatingButton(hasBottomBar)}
        onClick={() => onDialogOpen()}
      >
        <Filter />
        <TextV2 typographyVariant="hed1">{translations.filter()}</TextV2>
      </StyledFilterFloatingButton>
      <DrawerV2
        isOpen={isDialogOpen}
        onClose={onClose}
        disableAutoFocus
        anchor="top"
        size={1}
      >
        <DrawerV2.Header>
          <DrawerV2.CloseButton />
        </DrawerV2.Header>
        <DrawerV2.Body>
          <Box
            paddingX={7}
            paddingTop={1}
            paddingBottom={5}
            typographyVariant="hed2"
          >
            {translations.shopBy()}
          </Box>
          <Box paddingX={6}>
            {categories?.map(category => (
              <Flex
                key={category.id}
                paddingX={7}
                paddingY={4}
                borderRadius={21}
                {...(selectedItem?.id === category.id && { backgroundColor: 'mono3' })}
                onClick={() => onSelect(category)}
              >
                <StyleCheckbox
                  checked={selectedItem?.id === category.id}
                  onClick={e => e.stopPropagation()}
                  id={category.id}
                  label={category.title}
                  name="categoryFilter"
                />
              </Flex>
            ))}
          </Box>
        </DrawerV2.Body>
        <DrawerV2.Footer
          borderTop="1px solid"
          borderColor="mono3"
        >
          <Flex
            flexDirection="row"
            width="100%"
            columnGap={5}
          >
            <ButtonV2
              size="lg"
              variant="ghost"
              width="100%"
              color="mono14"
              shape="square"
              intent="neutral"
              onClick={onClearClick}
            >
              {translations.clearAll()}
            </ButtonV2>
            <ButtonV2
              size="lg"
              variant="solid"
              backgroundColor="mono14"
              width="100%"
              shape="square"
              intent="neutral"
              onClick={onConfirmClick}
            >
              {translations.confirm()}
            </ButtonV2>
          </Flex>
        </DrawerV2.Footer>
      </DrawerV2>
    </>
  );
};
